import React, { FC } from 'react';
import { ScrollView, Text, View } from 'react-native';
import Header from '@components/settings/v2/common/SettingsHeader';
import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import Loading from '@components/loading';
import Refresh from '@components/common/Refresh';
import { font } from '@styles/fonts';
import { useManageMachineCountSettings } from './hooks/useManageMachineCountSettings';
import SelectAutomaticallyBlock from './components/SelectAutomaticallyBlock';
import CountingMethodsBlock from './components/CountingMethodsBlock';
import QuantityBlock from './components/QuantityBlock';
import { BLOCKS_GAP } from './constants';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface MachineCountSettingsProps extends WithColor {}

const MachineCountSettings: FC<MachineCountSettingsProps> = ({ C }) => {
  const {
    backButtonAction,
    machine,
    countingMethods,
    currentCountingMethod,
    onCountingMethodChange,
    machineConnectionMethod,
    selectAutomaticallyConfig,
    countingMethodBlockTitle,
    isSelectAutomatically,
    machineCountingProfilesLoading,
    machineLoading,
    refetchMachine,
    countingMethodTextAndDescription,
    machineQuantityType,
    shouldDisplayQuantityType,
  } = useManageMachineCountSettings({ C });

  return (
    <View
      key="mainMachineContent"
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: C('Background/Light/Detail'),
        alignItems: 'center',
      }}
    >
      <Header
        name="MachinesOperationDetails"
        header="Count Settings"
        backButtonAction={backButtonAction}
        action={undefined}
        subHeader={undefined}
        actionLoading={undefined}
        actionActive={undefined}
      />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View
          style={{
            paddingHorizontal: scale(18),
          }}
        >
          {machineLoading && <Loading background={C('Background/Light/Detail')} />}
          {!machineLoading && !machine && <Refresh onPress={refetchMachine} />}
          {!machineLoading && machine && (
            <View testID={TEST_IDS.machineCountSettings.content}>
              <View style={{ alignItems: 'center', gap: scale(2) }}>
                <Text testID={TEST_IDS.machineCountSettings.machineName} style={[font['Title 2'], { color: C('Label/Light/Primary') }]}>
                  {machine.fullName}
                </Text>
                <Text testID={TEST_IDS.machineCountSettings.connectionMethodName} style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>
                  {machineConnectionMethod?.name}
                </Text>
              </View>
              <View style={{ marginTop: scale(20) }}>
                <SelectAutomaticallyBlock selectAutomaticallyConfig={selectAutomaticallyConfig} />
              </View>
              <View style={{ marginTop: scale(BLOCKS_GAP) }}>
                <CountingMethodsBlock
                  countingMethods={countingMethods || []}
                  isSelectAutomatically={isSelectAutomatically}
                  title={countingMethodBlockTitle}
                  loading={machineCountingProfilesLoading}
                  currentCountingMethod={currentCountingMethod}
                  onCountingMethodChange={onCountingMethodChange}
                  countingMethodText={countingMethodTextAndDescription.text}
                />
              </View>
                <View style={{ marginTop: scale(BLOCKS_GAP) }}>
                  <QuantityBlock
                    currentCountingMethod={currentCountingMethod}
                    quantityBlockDescription={countingMethodTextAndDescription.description}
                    machineQuantityType={machineQuantityType}
                    shouldDisplayQuantityType={shouldDisplayQuantityType}
                  />
                </View>
            </View>
          )}
        </View>
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(MachineCountSettings);
